// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --background-color: #1a1a1a;
  --text-color: #e0e0e0;
  --primary-color: #4dabf7;
  --secondary-color: #666;
}

html {
  background-color: var(--background-color);
}

.footer {
  color: var(--text-color);
}

body {
  background-color: var(--background-color);
  color: var(--text-color);
  font-family: 'Arial', sans-serif;
}

hr {
  color: var(--primary-color) !important;
}

.App {
  text-align: center;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: var(--background-color);
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

.card {
  position: static !important;
  margin: 0.5rem;
  overflow-x: auto;
  max-width: 100vw ;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 10vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(1.2rem + 2vw);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.nav-container {
  display: flex;
  gap: 20px;
  list-style: none;
  padding: 0;
  margin: 0;
}

.page {
  padding-top: 2rem;
  max-width: 100vw;
  margin: 0 auto;
  color: var(--text-color);
}

h1, h2 {
  color: var(--text-color) !important;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.app-container {
  display: flexbox;
  min-height: 100vh;
}

.sidebar {
  border-bottom: 1px solid #dee2e6!important;
  background-color: #282c34;
  height: 3.5rem;
  position: sticky;
  top: 0;
}

.content-area {
  flex: 1 1;
}

/* Pill style for NavLinks */
.nav-link {
  border-radius: 50px; /* Makes it a pill shape */
  padding: 10px 20px;
  margin-bottom: 10px;
  transition: all 0.3s ease;
  color: white !important; /* Explicitly set to white to override default link blue */
  text-decoration: none; /* Removes underline from hyperlink */
}

.nav-link:hover {
  background-color: rgba(77, 171, 247, 0.2); /* Primary color with low opacity */
  color: white !important;
}

.nav-link.active {
  background-color: var(--primary-color);
  color: white !important;
  font-weight: bold;
}

.main-btn {
  background-color: var(--primary-color);
  border: none;
  color: white;
  padding: 1rem 2rem;
  border-radius: 25px;
  font-size: 1.2rem;
  transition: all 0.3s ease;
}

.main-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 8px 12px rgba(0, 0, 0, 0.2);
}

.bi-download {
  margin-right: 10px;
}

.nav-header {
  text-align: center;
  text-decoration: none;
}

.navbar-toggler {
    appearance: none;
    cursor: pointer;
    width: 3.5rem;
    height: 2.5rem;
    color: white;
    position: absolute;
    top: 0.5rem;
    right: 1rem;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center/1.75rem rgba(255, 255, 255, 0.1);
}

.navbar-toggler:checked {
    background-color: rgba(255, 255, 255, 0.5);
}

.nav-scrollable {
    display: none;
}

.navbar-toggler:checked ~ .nav-scrollable {
    display: block;
    background-color: #282c34;
    border-bottom: 1px solid #dee2e6!important;
    padding-top: 10px;
}


.top-row {
    justify-content: flex-end;
    height: 3.5rem;
    display: flex;
    align-items: center;
}

    .top-row ::deep a, .top-row ::deep .btn-link {
        white-space: nowrap;
        margin-left: 1.5rem;
        text-decoration: none;
    }

        .top-row ::deep a:hover, .top-row ::deep .btn-link:hover {
            text-decoration: underline;
        }

        .top-row ::deep a:first-child {
            overflow: hidden;
            text-overflow: ellipsis;
        }

@media (max-width: 640.98px) {
    .top-row {
        justify-content: space-between;
    }

        .top-row ::deep a, .top-row ::deep .btn-link {
            margin-left: 0;
        }
}

@media (min-width: 641px) {

    .navbar-toggler {
        display: none;
    }

    .nav-scrollable {
        /* Never collapse the sidebar for wide screens */
        display: block;

        /* Fill the remaining sidebar height and scroll for tall menus */
        flex: 1 1;
        min-height: 0;
        overflow-y: auto;
        border-bottom: none!important;
    }
    
    .sidebar {
      border-right: 1px solid #dee2e6!important;
      border-bottom: none!important;
      background-color: #282c34;
      padding: 20px;
      height: 100vh;
      display: flex;
      flex-direction: column;
      position: sticky;
      top: 0;
    }
    
    .App {
      text-align: center;
      min-height: 100vh;
      display: flex;
      flex-direction: row;
      background-color: var(--background-color);
    }

    .content-area {
      flex: 1 1;
      padding: 2rem;
    }
    
    .top-row {
        position: sticky;
        top: 0;
        z-index: 1;
    }

        .top-row.auth ::deep a:first-child {
            flex: 1 1;
            text-align: right;
            width: 0;
        }

    .top-row, article {
        padding-left: 2rem !important;
        padding-right: 1.5rem !important;
    }
}

/* Employment history card header: title centred with the filter switch on the
   right, dropping the switch to its own line once the header gets too narrow
   for both to sit comfortably side by side. */
.employment-header {
  position: relative;
  container-type: inline-size;
  container-name: employment-header;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.5rem 1rem;
}

.employment-header__title {
  flex: 0 0 100%;
  text-align: center;
}

.employment-header__filter {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0;
  white-space: nowrap;
}

@container employment-header (min-width: 40rem) {
  .employment-header__title {
    flex: 0 0 auto;
  }

  .employment-header__filter {
    position: absolute;
    top: 50%;
    right: 1rem;
    transform: translateY(-50%);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yCAAyC;EACzC,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,SAAO;AACT;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB,EAAE,0BAA0B;EAC/C,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB,EAAE,0DAA0D;EACnF,qBAAqB,EAAE,qCAAqC;AAC9D;;AAEA;EACE,yCAAyC,EAAE,mCAAmC;EAC9E,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,0CAA0C;IAC1C,qGAA+S;AACnT;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,0CAA0C;IAC1C,iBAAiB;AACrB;;;AAGA;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;IAEI;QACI,mBAAmB;QACnB,mBAAmB;QACnB,qBAAqB;IACzB;;QAEI;YACI,0BAA0B;QAC9B;;QAEA;YACI,gBAAgB;YAChB,uBAAuB;QAC3B;;AAER;IACI;QACI,8BAA8B;IAClC;;QAEI;YACI,cAAc;QAClB;AACR;;AAEA;;IAEI;QACI,aAAa;IACjB;;IAEA;QACI,gDAAgD;QAChD,cAAc;;QAEd,gEAAgE;QAChE,SAAO;QACP,aAAa;QACb,gBAAgB;QAChB,6BAA6B;IACjC;;IAEA;MACE,yCAAyC;MACzC,6BAA6B;MAC7B,yBAAyB;MACzB,aAAa;MACb,aAAa;MACb,aAAa;MACb,sBAAsB;MACtB,gBAAgB;MAChB,MAAM;IACR;;IAEA;MACE,kBAAkB;MAClB,iBAAiB;MACjB,aAAa;MACb,mBAAmB;MACnB,yCAAyC;IAC3C;;IAEA;MACE,SAAO;MACP,aAAa;IACf;;IAEA;QACI,gBAAgB;QAChB,MAAM;QACN,UAAU;IACd;;QAEI;YACI,SAAO;YACP,iBAAiB;YACjB,QAAQ;QACZ;;IAEJ;QACI,6BAA6B;QAC7B,gCAAgC;IACpC;AACJ;;AAEA;;8CAE8C;AAC9C;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,iCAAiC;EACjC,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,2BAA2B;EAC7B;AACF","sourcesContent":[":root {\n  --background-color: #1a1a1a;\n  --text-color: #e0e0e0;\n  --primary-color: #4dabf7;\n  --secondary-color: #666;\n}\n\nhtml {\n  background-color: var(--background-color);\n}\n\n.footer {\n  color: var(--text-color);\n}\n\nbody {\n  background-color: var(--background-color);\n  color: var(--text-color);\n  font-family: 'Arial', sans-serif;\n}\n\nhr {\n  color: var(--primary-color) !important;\n}\n\n.App {\n  text-align: center;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background-color: var(--background-color);\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n.card {\n  position: static !important;\n  margin: 0.5rem;\n  overflow-x: auto;\n  max-width: 100vw ;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 10vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(1.2rem + 2vw);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.nav-container {\n  display: flex;\n  gap: 20px;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.page {\n  padding-top: 2rem;\n  max-width: 100vw;\n  margin: 0 auto;\n  color: var(--text-color);\n}\n\nh1, h2 {\n  color: var(--text-color) !important;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\n}\n\n.app-container {\n  display: flexbox;\n  min-height: 100vh;\n}\n\n.sidebar {\n  border-bottom: 1px solid #dee2e6!important;\n  background-color: #282c34;\n  height: 3.5rem;\n  position: sticky;\n  top: 0;\n}\n\n.content-area {\n  flex: 1;\n}\n\n/* Pill style for NavLinks */\n.nav-link {\n  border-radius: 50px; /* Makes it a pill shape */\n  padding: 10px 20px;\n  margin-bottom: 10px;\n  transition: all 0.3s ease;\n  color: white !important; /* Explicitly set to white to override default link blue */\n  text-decoration: none; /* Removes underline from hyperlink */\n}\n\n.nav-link:hover {\n  background-color: rgba(77, 171, 247, 0.2); /* Primary color with low opacity */\n  color: white !important;\n}\n\n.nav-link.active {\n  background-color: var(--primary-color);\n  color: white !important;\n  font-weight: bold;\n}\n\n.main-btn {\n  background-color: var(--primary-color);\n  border: none;\n  color: white;\n  padding: 1rem 2rem;\n  border-radius: 25px;\n  font-size: 1.2rem;\n  transition: all 0.3s ease;\n}\n\n.main-btn:hover {\n  transform: scale(1.05);\n  box-shadow: 0 8px 12px rgba(0, 0, 0, 0.2);\n}\n\n.bi-download {\n  margin-right: 10px;\n}\n\n.nav-header {\n  text-align: center;\n  text-decoration: none;\n}\n\n.navbar-toggler {\n    appearance: none;\n    cursor: pointer;\n    width: 3.5rem;\n    height: 2.5rem;\n    color: white;\n    position: absolute;\n    top: 0.5rem;\n    right: 1rem;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\") no-repeat center/1.75rem rgba(255, 255, 255, 0.1);\n}\n\n.navbar-toggler:checked {\n    background-color: rgba(255, 255, 255, 0.5);\n}\n\n.nav-scrollable {\n    display: none;\n}\n\n.navbar-toggler:checked ~ .nav-scrollable {\n    display: block;\n    background-color: #282c34;\n    border-bottom: 1px solid #dee2e6!important;\n    padding-top: 10px;\n}\n\n\n.top-row {\n    justify-content: flex-end;\n    height: 3.5rem;\n    display: flex;\n    align-items: center;\n}\n\n    .top-row ::deep a, .top-row ::deep .btn-link {\n        white-space: nowrap;\n        margin-left: 1.5rem;\n        text-decoration: none;\n    }\n\n        .top-row ::deep a:hover, .top-row ::deep .btn-link:hover {\n            text-decoration: underline;\n        }\n\n        .top-row ::deep a:first-child {\n            overflow: hidden;\n            text-overflow: ellipsis;\n        }\n\n@media (max-width: 640.98px) {\n    .top-row {\n        justify-content: space-between;\n    }\n\n        .top-row ::deep a, .top-row ::deep .btn-link {\n            margin-left: 0;\n        }\n}\n\n@media (min-width: 641px) {\n\n    .navbar-toggler {\n        display: none;\n    }\n\n    .nav-scrollable {\n        /* Never collapse the sidebar for wide screens */\n        display: block;\n\n        /* Fill the remaining sidebar height and scroll for tall menus */\n        flex: 1;\n        min-height: 0;\n        overflow-y: auto;\n        border-bottom: none!important;\n    }\n    \n    .sidebar {\n      border-right: 1px solid #dee2e6!important;\n      border-bottom: none!important;\n      background-color: #282c34;\n      padding: 20px;\n      height: 100vh;\n      display: flex;\n      flex-direction: column;\n      position: sticky;\n      top: 0;\n    }\n    \n    .App {\n      text-align: center;\n      min-height: 100vh;\n      display: flex;\n      flex-direction: row;\n      background-color: var(--background-color);\n    }\n\n    .content-area {\n      flex: 1;\n      padding: 2rem;\n    }\n    \n    .top-row {\n        position: sticky;\n        top: 0;\n        z-index: 1;\n    }\n\n        .top-row.auth ::deep a:first-child {\n            flex: 1;\n            text-align: right;\n            width: 0;\n        }\n\n    .top-row, article {\n        padding-left: 2rem !important;\n        padding-right: 1.5rem !important;\n    }\n}\n\n/* Employment history card header: title centred with the filter switch on the\n   right, dropping the switch to its own line once the header gets too narrow\n   for both to sit comfortably side by side. */\n.employment-header {\n  position: relative;\n  container-type: inline-size;\n  container-name: employment-header;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem 1rem;\n}\n\n.employment-header__title {\n  flex: 0 0 100%;\n  text-align: center;\n}\n\n.employment-header__filter {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0;\n  white-space: nowrap;\n}\n\n@container employment-header (min-width: 40rem) {\n  .employment-header__title {\n    flex: 0 0 auto;\n  }\n\n  .employment-header__filter {\n    position: absolute;\n    top: 50%;\n    right: 1rem;\n    transform: translateY(-50%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
